import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './Sidebar.module.css';
import ZINDEXES from '@/constants/zIndexes';
import { appRoutes } from '@/routes';

export default function Sidebar({ collapsed, toggleCollapsed, loading }) {
    const location = useLocation();
    const userData = useSelector((state) => state.user.userData);
    const userRole = userData?.role;

    const menuItems = appRoutes
        .filter((route) => !route.hidden)
        .filter((route) => !route.roles || route.roles.includes(userRole));

    // Skeleton item for loading
    const SkeletonItem = () => (
        <div className="flex items-center gap-3 px-4 py-3 animate-pulse">
            <div className="bg-gray-500 rounded w-5 h-5" />
            {!collapsed && <div className="bg-gray-500 rounded h-4 w-24" />}
        </div>
    );

    return (
        <div
            className={`relative bg-primary-950 text-white h-screen transition-all duration-300 flex flex-col ${
                collapsed ? 'w-16' : 'w-64'
            }`}
            style={{ zIndex: ZINDEXES.SIDEBAR }}
        >
            <button className={styles.collapseBtn} onClick={toggleCollapsed}>
                {collapsed ? (
                    <ChevronRight size={24} />
                ) : (
                    <ChevronLeft size={24} />
                )}
            </button>

            <nav className="space-y-1 me-1">
                {loading
                    ? Array(6) // number of skeleton menu items
                          .fill(0)
                          .map((_, idx) => <SkeletonItem key={idx} />)
                    : menuItems.map((item) => {
                          const isActive = location.pathname === item.path;
                          const Icon = item.icon;

                          return (
                              <Link
                                  key={item.path}
                                  to={item.path}
                                  className={`flex items-center gap-3 px-4 py-3 hover:bg-primary-100 ${
                                      isActive ? 'bg-secondary-100' : ''
                                  }`}
                              >
                                  <Icon
                                      size={18}
                                      strokeWidth={2}
                                      className={`${isActive ? 'text-primary-950' : 'text-white'}`}
                                  />

                                  {!collapsed && (
                                      <span
                                          className={`text-sm text-nowrap ${
                                              isActive ? 'text-primary-950' : ''
                                          }`}
                                      >
                                          {item.title}
                                      </span>
                                  )}
                              </Link>
                          );
                      })}
            </nav>
        </div>
    );
}
